// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__ZQiub","buttons":"NotFound_buttons__1x7NV","phone1":"NotFound_phone1__cFDor","phone2":"NotFound_phone2__ewp-i","qrCube":"NotFound_qrCube__UWWD2"};